const projects = [
  {
    id: 1,
    title: "LaraMoney",
    description:"Programa para calcular ingresos y egresos por cliente, construido con Laravel y la libreria Bootstrap",
    url: "https://github.com/SubjectZeroo/Laramoney",
    img: require('@/assets/projects/web-project-1.png'),
  },
  {
    id: 2,
    title: "Website-Gym ",
    description: "Landing Page sobre un Gym construida con HTML5 Y procesador PUG, y agregandole estilos con CSS3 y el procesador SCSS y la metodologia BEM",
    url: "https://github.com/SubjectZeroo/Website-Gym",
    img: require('@/assets/projects/web-project-2.png'),
  },
  {
    id: 3,
    title: "Portfolio",
    description:"Portafolio para mostrar mi trabajo contruidos con la tecnologia VUEJS Y diseñado con Tailwind CSS",
    url: "https://github.com/SubjectZeroo/Portafolio",
    img: require('@/assets/projects/web-project-3.png'),
  },
  {
    id: 4,
    title: "DevBlog-CMS ",
    description:"DevBlog app para visualizar blogs con un pequeno CMS para el usuario para administrar el contenido de la pagina Hecho en PHP",
    url: "https://github.com/SubjectZeroo/DevBlog-CMS",
    img: require('@/assets/projects/web-project-4.svg'),
  },
  {
    id: 5,
    title: "Twitter Clone",
    description:
      "El objetivo del proyecto era hacer algo parecido a Twitter con la tecnologia de Laravel y diseño hecho con Tailwind CSS.",
    url: "https://github.com/SubjectZeroo/Twitter-Clone",
    img: require('@/assets/projects/web-project-5.png'),
  },
  {
    id: 6,
    title: "Project Manager",
    description:"Aplicación para llevar notas al estilo Kanban donde se pueden invitar a compañeros a participar y informar sobre la nota, construido con tecnologia Laravel y la libreria Bootstrap",
    url: "https://github.com/SubjectZeroo/Project-Manager",
    img: require('@/assets/projects/web-project-6.png'),
  },
];

export default projects;
